import React from 'react';
import './BottomFilterBar.scss';
import { getSortLabel } from '../../SortPanel/sortHelper';

const BottomFilterBar = ({
  order,
  sortWrapperRef,
  toggleSortDropdown,
  toggleFilterMobile,
  appliedTypeCount,
}) => {
  return (
    <div className="bottom-filter-bar">
      <div
        ref={sortWrapperRef}
        className="bottom-filter-bar__item bottom-filter-bar__item--sort"
        onClick={toggleSortDropdown}
      >
        <div className="bottom-filter-bar__item__top">
          <span className="bottom-filter-bar__item__icon" />
          <span className="bottom-filter-bar__item__label">Sort</span>
        </div>
        <div className="bottom-filter-bar__item__desc">{getSortLabel(order)}</div>
      </div>
      <div className="bottom-filter-bar__divider" />
      <div
        className="bottom-filter-bar__item bottom-filter-bar__item--filter"
        onClick={toggleFilterMobile}
      >
        <div className="bottom-filter-bar__item__top">
          <span className="bottom-filter-bar__item__icon" />
          <span className="bottom-filter-bar__item__label">Filter</span>
        </div>
        <div className="bottom-filter-bar__item__desc">
          {appliedTypeCount > 0 ? (
            <span className="filter-badge">
              <span className="filter-badge__count">{appliedTypeCount}</span> Applied
            </span>
          ) : (
            'No filters applied'
          )}
        </div>
      </div>
    </div>
  );
};

export default BottomFilterBar;
